export const SET_INPUTS_HIDDEN = 'searchContainer/SET_INPUTS_HIDDEN';
export const TOGGLE_INPUTS_HIDDEN_ON_MOBILE = 'searchContainer/TOGGLE_INPUTS_HIDDEN_ON_MOBILE';
export const RESET_INPUTS_HIDDEN = 'searchContainer/RESET_INPUTS_HIDDEN';
export const RESET_INPUTS_HIDDEN_ON_MOBILE = 'searchContainer/RESET_INPUTS_HIDDEN_ON_MOBILE';
